import { gql } from '__generated__';

export default gql(`
  mutation EditOrderFromDashboard($input: EditOrderInput!) {
    editOrder(input: $input) {
      ...OrderFields
    }
  }
`);
